import { useState } from 'react';
import { HeartIcon, GownIcon } from '../components/Icons';

function ProductCard({ product, wishlist, onWishlist, onNavigate }) {
  const isWished = wishlist.includes(product.id);
  return (
    <div
      onClick={() => onNavigate('productdetail', { product })}
      className="bg-white rounded-xl overflow-hidden border border-gray-100 hover:shadow-md transition-all cursor-pointer hover:scale-[1.01]"
    >
      <div className="aspect-square flex items-center justify-center relative overflow-hidden bg-gray-50">
        {product.image ? (
          <img src={product.image} alt={product.name} className="w-full h-full object-cover" onError={e => { e.target.style.display = 'none'; }} />
        ) : (
          <GownIcon className="w-8 h-8 text-gray-300" />
        )}
      </div>
      <div className="p-2">
        <p className="font-semibold text-[#1A1A2E] text-xs leading-tight line-clamp-1">{product.name}</p>
        {product.description ? (
          <p className="text-gray-400 text-[10px] mt-0.5 mb-1 line-clamp-1">{product.description}</p>
        ) : <div className="mb-1" />}
        <div className="flex items-center justify-between">
          <div>
            <span className="font-bold text-[#1A1A2E] text-xs">
              {product.priceStr || `₦${product.price?.toLocaleString()}`}
            </span>
            {product.original_price && product.original_price > product.price ? (
              <span className="ml-1 text-gray-400 text-[10px] line-through">
                {`₦${Number(product.original_price).toLocaleString()}`}
              </span>
            ) : null}
          </div>
          <button
            onClick={(e) => { e.stopPropagation(); onWishlist(product.id); }}
            className={`p-1 rounded-full transition-colors ${isWished ? 'text-[#F47B20]' : 'text-gray-300 hover:text-[#F47B20]'}`}
          >
            <HeartIcon className="w-4 h-4" filled={isWished} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default function CategoryPage({ onNavigate, category, products = [] }) {
  const [wishlist, setWishlist] = useState([]);

  const toggleWishlist = (id) =>
    setWishlist(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);

  const categoryProducts = (products || []).filter(
    p => String(p.category_id) === String(category?.id) && p.status !== 'draft'
  );

  return (
    <div className="bg-[#FAF3F0] min-h-screen">
      {/* ── Header ── */}
      <div className="sticky top-0 z-30 bg-white border-b border-gray-100 px-4 lg:px-12 xl:px-16 py-2.5 flex items-center gap-2.5 shadow-sm w-full mx-auto">
        <button
          onClick={() => onNavigate('shop')}
          className="w-8 h-8 flex items-center justify-center rounded-full bg-[#FEF0E6] text-[#F47B20] hover:bg-[#F47B20] hover:text-white transition-colors"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        {category?.image_url && (
          <div className="w-8 h-8 rounded-lg overflow-hidden border border-gray-100">
            <img src={category.image_url} alt={category.name} className="w-full h-full object-cover" />
          </div>
        )}
        <div>
          <h1 className="text-sm font-bold text-[#1A1A2E] leading-tight">{category?.name || 'Category'}</h1>
          <p className="text-[10px] text-gray-400">{categoryProducts.length} product{categoryProducts.length !== 1 ? 's' : ''}</p>
        </div>
      </div>

      {/* ── Products Grid ── */}
      <div className="w-full mx-auto px-4 lg:px-12 xl:px-16 mt-4 pb-28 lg:pb-8">
        {categoryProducts.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:auto-grid-products gap-2 lg:gap-4">
            {categoryProducts.map(product => (
              <ProductCard key={product.id} product={product} wishlist={wishlist} onWishlist={toggleWishlist} onNavigate={onNavigate} />
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <GownIcon className="w-16 h-16 text-gray-200 mx-auto mb-4" />
            <p className="text-gray-400 font-semibold text-base">No products in this category yet</p>
            <p className="text-gray-300 text-sm mt-1">Check back soon!</p>
            <button
              onClick={() => onNavigate('shop')}
              className="mt-5 px-5 py-2.5 bg-[#F47B20] text-white text-sm font-bold rounded-xl hover:bg-[#D96A10] transition-colors"
            >
              Browse All Products
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
